import React from 'react';

export const ButtonPrev = ({ buttonPrevHidden, buttonPrevAction, currentStep, changeCurrentStep, buttonPrevText }) => {
    const handlePrevStep = () => {
        changeCurrentStep({
            index: parseInt(currentStep, 10) - 1,
        });
    };
    const buttonClass = buttonPrevHidden
        ? 'hidden'
        : 'form__button form__button-negative roadmap-navigation__button-prev';
    const handleClick = buttonPrevAction ?? handlePrevStep;

    return (
        <button className={buttonClass} type="button" onClick={handleClick} data-testid="button-prev">
            {buttonPrevText}
        </button>
    );
};
